import * as React from 'react';
import { Shadow1dp } from 'elc-layouts';
import {
    StyledColumn,
    FilterList,
    SelectedFilterListItem,
    SelectedFilterHeading,
    FilterListItem,
    FilterHeading
} from './ShadeFilterColumnStyles';

export const filters = ['ALL', 'REDS', 'PURPLE', 'NUDE', 'PINK'];
const FilterListItemDisplay = (filter: string) => (
    <FilterListItem key={`filter-item-${filter}`}>
        <FilterHeading>{filter}</FilterHeading>
    </FilterListItem>
);

export const FilterListDisplay = ({ filters: filtersList }: { filters: string[] }) => (
    <>{filtersList.map(FilterListItemDisplay)}</>
);

export const ShadeFilterColumn = () => {
    const [filterHeading, ...remainingFilters] = filters;

    return (
        <StyledColumn>
            <Shadow1dp>
                <FilterList>
                    <SelectedFilterListItem>
                        <SelectedFilterHeading>{filterHeading}</SelectedFilterHeading>
                    </SelectedFilterListItem>
                    <FilterListDisplay filters={remainingFilters} />
                </FilterList>
            </Shadow1dp>
        </StyledColumn>
    );
};
